new Search("#search",
    {
        url: "index.php?route=product/search_ajax/search",
        dropdownSelector: ".bar-search__list",
        inputSelector: ".bar-search__input",
        buttonSelector: ".bar-search__btn",
        symbolCount: 4
    }
);

new Cart("#cart", ".in-cart__buy",
    {
        button: ".cart-btn",
        popup: ".cart-popup",
        delete: ".cart-popup__del",
        overlay: ".overlay"
    },
    {
        add: "index.php?route=checkout/cart/add",
        remove: "index.php?route=checkout/cart/remove",
        edit: "index.php?route=checkout/cart/edit",
        info: "index.php?route=common/cart/info"
    }
);

new SpiBox(".spin-box",
    {
        down: ".spin-box__down",
        input: ".spin-box__input",
        up: ".spin-box__up",
        disabledBtn: "spin-box__btn--disabled"
    }
);

new JsonLd(".json-ld");

new Review();

// FILTER START
const btnFilter = document.querySelector('#button-filter');
if (btnFilter) {
    btnFilter.addEventListener('click', (e) => {
        let filter = [];
        document.querySelectorAll('input[name^="filter"]:checked').forEach((el) => {
            filter.push(el.value);
        });
        return window.location.assign(btnFilter.dataset.action + '&filter=' + [...new Set(filter)].join(','));
    });
}
// FILTER END

// CURRENCY SEND FORM START
document.querySelectorAll('#form-currency button').forEach((el) => {
    el.addEventListener('click', (e) => {
        const form = document.querySelector('#form-currency');
        form.elements['code']['value'] = e.target.name
        form.submit()
    });
});
// CURRENCY SEND FORM END


// HEADER FIXED START
const bar = document.querySelector('.bar');

window.addEventListener('scroll', () => {
    if (window.scrollY > 300) {
        bar.classList.add("bar--fixed");
    } else {
        bar.classList.remove("bar--fixed");
    }
}); // HEADER FIXED END


// SLIDERs START
const swiper = new Swiper('.slider-block', {
    sliderPerView: 1,
});

document.querySelectorAll('.slider-nav__item').forEach((el, index) => {
    el.addEventListener('click', (e) => {
        const index = parseInt(e.currentTarget.dataset.index);

        swiper.slideTo(index);
    });
});

const sliderCard = new Swiper('.slider-card', {
    freeMode: true,
    slidesPerView: 'auto',
    spaceBetween: 5,
}); // SLIDERs END

const mainMenu = new MainMenu();
mainMenu.toggle();
mainMenu.close();

// HIDE DESCRIPTION PRODUCT START
const showDescription = document.querySelector('#show-description');
const tabDescription = document.querySelector('#tab-description div:first-child');
if (tabDescription && showDescription) {
    if (tabDescription.offsetHeight < 320) {
        showDescription.remove()
    }
}
// HIDE DESCRIPTION PRODUCT END

document.addEventListener('click', (e) => {

    // HIDE DESCRIPTION PRODUCT START
    // const showDescription = document.querySelector('#show-description');
    // const tabDescription = document.querySelector('#tab-description div:first-child');

    if (tabDescription && showDescription) {
        const iconExpandCollapse = showDescription.querySelector('i').classList;

        if (showDescription.contains(e.target)) {
            if (tabDescription.style.getPropertyValue('max-height') == '100%') {
                tabDescription.style.maxHeight = '20rem';
                iconExpandCollapse.replace('bi-arrows-collapse', 'bi-arrows-expand');
            } else {
                tabDescription.style.maxHeight = '100%';
                iconExpandCollapse.replace('bi-arrows-expand', 'bi-arrows-collapse');
            }
        }

    }
    // HIDE DESCRIPTION PRODUCT END

    if (document.querySelector('.userbar').contains(e.target)) {
        document.querySelector('.userbar-popup').classList.add('active');
    } else {
        document.querySelector('.userbar-popup').classList.remove('active');
    }

    // HIDE DESCRIPTION IN CATEGORY START
    const categoryTitle = document.querySelector('.category');

    if (categoryTitle) {

        const categoryDescription = categoryTitle.querySelector('.category__description')
        if (categoryDescription) {
            if (categoryTitle.contains(e.target)) {
                categoryDescription.style.display = 'block';
                categoryDescription.style.position = 'relative';
            } else {
                categoryDescription.style.display = 'none';
                categoryDescription.style.position = 'absolute';
            }
        }
    }
    // HIDE DESCRIPTION IN CATEGORY END

    const search = document.querySelector('.bar-search__list');
    (search.contains(e.target)) ? search.classList.add('active') : search.classList.remove('active');

    document.querySelectorAll('.dropmenu').forEach(el => {
        const cl = el.querySelector('.dropmenu-content').classList;

        if (el.contains(e.target)) {
            if (cl.contains('show')) {
                cl.remove('show');
            } else {
                cl.add('show');
                const width = document.documentElement.clientWidth;
                const mouseX = e.pageX;
                if (mouseX > (width / 2)) {
                    cl.add('right');
                    cl.remove('left');
                } else {
                    cl.add('left');
                    cl.remove('right');
                }
            }
        } else {
            cl.remove('show')
        }
    });

    document.querySelectorAll('.mainmenu__item').forEach(el => {
        const s = el.querySelector('.mainmenu-childs');
        if (s) {
            if (el.contains(e.target)) {
                s.style.display = (getComputedStyle(s).display == 'none') ? 'flex' : 'none';
            } else {
                s.style.display = 'none';
            }
        }
    });

    document.querySelectorAll('.icon-btn svg').forEach(el => {
        btn = el.classList
        if (el.contains(e.target)) {
            btn.contains('rotate') ? btn.remove('rotate') : btn.add('rotate')
        } else {
            btn.remove('rotate')
        }
    });
});

new LightBox();
